import axios from "axios";

const postCupon = async cupon => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
    cupon: cupon,
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/test`, userData);
  return response;
};

const cuponTest = {
  postCupon,
};

export default cuponTest;
